import React from 'react';
import { Link } from 'react-router-dom';

import '../../Assets/Layout/Header.css';

import AuthService from '../../Services/AuthService';

export default class Header extends React.Component {
    render() {
        const { onMenuToggle, menuOpen } = this.props;

        return (
            <div className="Header">
                <button
                    className="mobile-toggle"
                    onClick={onMenuToggle}
                    aria-label="Toggle menu"
                >
                    <i className={menuOpen ? 'zmdi zmdi-close' : 'zmdi zmdi-menu'} />
                </button>
                <Link to="/" className="logo">
                    <img src="/assets/images/logo_feeli_color.png" alt="Logo" />
                    <span>Dashboard</span>
                </Link>
                <div className="right">
                    <ul>
                        <li onClick={() => {
                            new AuthService().logout();
                            this.props.history.push('/login');
                        }} style={{ cursor: 'pointer' }}>
                            <i className="zmdi zmdi-power" style={{ marginRight: '8px' }} />
                            Déconnexion
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}
